<template>
    <div class="navbar" v-bind:class="{'navbar-transparent':isTrans}">
        <div class="container">
            <div class="nav-left" v-show="isShowbar">
                <div class="navbar-header">
                    <div class="ifree-logo">
                        <router-link :to="{name: 'Home'}">
                            <img class="logo" :src="logo" width="100%">
                        </router-link>
                    </div>
                    <button type="button" class="navbar-toggle" @click="navToggle">
                        <Icon type="navicon"></Icon>
                    </button>
                </div>
                <ul class="nav nav-default" v-bind:class="{active:navStatus}" v-show="isNav">
                    <li v-for="(item,index) in menu" v-bind:class="{active:item.to.name==activeTo}" @mouseover="ThisShow(index)">
                        <router-link :to="item.to" @click.native="menuToggle(index)">{{item.name}}</router-link>
                    </li>
                </ul>
            </div>
            <div class="nav-right" v-bind:class="{active:navStatus}" >
                <ul class="nav nav-default nav-no-hover">
                    <span class="search_bar">
                        <li v-bind:class="{active:searchStatus}" class="nav-search">
                            <input type="text" v-model="searchText" @keyup.enter="search" :placeholder="$t('enter_keyword')" style="padding:0;font-size: 24px;line-height: 32px;">
                        </li>
                        <li class="close_search" v-show="isClose">
                            <a href="javascript:;" @click="close_search">
                                <img src="../../assets/home/icon-close.png" />
                            </a>
                        </li>
                    </span>
                    <span  v-show="isShowbar" style="display:flex;">
                        <li class="search-icon" >
                        <a href="javascript:;" @click="searchToggle">
                            <img :src="searchBtn" width="20" />
                        </a>
                    </li>
                    <li class="shopping">
                        <a href="javascript:;" @click="shopping">
                            <img class="shopping-cart" :src="shoppingCart" width="20">
                            <sup :style="{display:cartCount === 0 ?'none':'inline'}">{{cartCount}}</sup>
                        </a>
                    </li>

                    <li @click="modal1 = true" v-if="!isLogin">
                        <a href="javascript:;" @click="loginThis">
                            <img class="my-user" :src="myUser" width="20">
                        </a>
                    </li>
                    <li v-if="isLogin">
                        <a href="javascript:;" @click="showUserMenu">
                            <img class="my-user" :src="myUser" width="20">
                        </a>
                        <ul class="dropdown-menu dropdown-user" v-bind:class="{active:showMenuStatus}">
                            <li>
                                <a href="javascript:;"><span>{{nickname}}</span></a>
                            </li>
                            <li>
                                <router-link :to="{name:'Personal'}"><span>{{$t('personal_center')}}</span>
                                </router-link>
                            </li>
                            <li>
                                <router-link :to="{name:'iPoint'}"><span>{{$t('top_up')}}</span></router-link>
                            </li>
                            <li>
                                <router-link :to="{name:'app'}"><span>iAPP</span></router-link>
                            </li>
                            <li>
                                <a href="javascript:;" @click="logout"><span>{{$t('sign_out')}}</span></a>
                            </li>
                        </ul>
                    </li>
                    <li class="mobile-shopping">
                        <router-link :to="{name:'ShoppingCart'}">
                            <img class="shopping-cart" src="../../assets/shopping_cart_black.png" width="20">
                            <sup :style="{display:cartCount === 0 ?'none':'inline'}">{{cartCount}}</sup>
                        </router-link>
                    </li>
                    <li>
                        <a href="javascript:;" @click="dropdownToggle">
                            <img :src="defaultLanguage.flag" width="30">
                            <span>{{defaultLanguage.value}}</span>

                            <img class="unfold" :src="unfold" width="10">
                        </a>
                        <ul class="dropdown-menu" v-bind:class="{active:dropdownStatus}">
                            <li v-for="(item,index) in language" :key="index" @click="toggleLanguage(item.label)">
                                <a href="javascript:;">
                                    <img :src="item.flag" width="30">
                                    <span>{{item.value}}</span>
                                </a>
                            </li>
                        </ul>
                    </li>
                    </span>
                </ul>
            </div>

        </div>
        <!--Conect-->
        <transition name="slide-fade">
            <div class="nav-Conect" v-show="ConectShow"  @mouseleave="ConectHide()">
                <div class="nav-Conect-wrap">
                    <ol>
                        <li v-for="(item,index) in submenulist" :key="index">
                            <router-link :to="item.to" @click.native="submenuToggle(index)">
                                <img :src="item.grey"  width="56" class="grey-icon">
                                <img :src="item.blue"   width="56" class="blue-icon">
                                <p>
                                    {{item.name}}
                                </p>
                            </router-link>
                        </li>
                    </ol>
                </div>
            </div>
        </transition>
        <!--用户绑定邮箱-->
        <modal v-model="bind_email"  size="small" @on-ok="fb_bind_email" class="bind_email">
            <div slot="header"></div>
            <div class="page-content" style="text-align: center">
                <div class="bind_email_title">
                    <h2>{{$t('bind_email_title')}}</h2>
                </div>
                <div class="bind_email_sm-title">
                    <p>{{$t('bind_email_modal_tips')}}</p>
                </div>
                <div class="bind_email_input">
                    <input type="email" v-model="bind_email_email" name="forget psw email" :placeholder="$t('user_center_email')">
                </div>
                <div class="bind_email_input">
                    <input type="password" v-model="bind_email_psw" name="forget psw email" :placeholder="$t('user_center_password')">
                </div>
                <div class="bind_email_determine">
                    <button @click="fb_bind_email">{{$t('determine_btn')}}</button>
                </div>
            </div>
            <div slot="footer"></div>
        </modal>
        <!--忘记密码窗口-->
        <modal v-model="forget_moadl" size="small" class="forget_password">
            <Spin size="large" fix v-if="spinShow_forget"></Spin>
            <div slot="header"></div>
            <div class="page-content">
                <div class="forget_password-title">
                    <h2>{{$t('user_center_retrieve_password')}}</h2>
                </div>
                <div class="forget_password-sm-title">
                    <p>{{$t('user_center_forget_password_sub_title')}}</p>
                </div>
                <div class="forget_password-main">
                    <input type="email" v-model="forget_psw_email" name="forget psw email"
                           :placeholder="$t('user_center_email')">
                </div>
                <div class="forget_password-nex-btn">
                    <button @click="forget_password_next">{{$t('next')}}</button>
                </div>
            </div>
            <div slot="footer"></div>
        </modal>
        <!--游客登录-->
        <modal v-model="TouristLogin" size="large"  class="TouristLogin">
            <div slot="header"></div>
            <div class="page-content" style="text-align: center">
                <h1 class="font_big TouristLogin_title">{{$t('tourist_title')}}</h1>
                <Row>
                    <i-col :xs="24" :sm="12" :md="12" :lg="12" class="TouristLogin_login">
                        <!--游客登录-->
                        <div class="TouristLogin_loginwrap" v-if="this.TouristShow == true">
                            <h2 class="font_mid">
                                {{$t('tourist_member')}}
                            </h2>
                            <form>
                                <div class="TouristLogin_email">
                                    <input type="text" name="username" v-model="touristName" :placeholder="$t('user_center_email')">
                                </div>
                                <div class="TouristLogin_password" style="position: relative">
                                    <input type="password" class="Touristpassword_1" name="password" v-model="touristPassword" :placeholder="$t('user_center_password')">
                                    <img v-if="showthis_1 === 'a'" src="../../assets/icon_eye.png" @click="hide()" width="30"
                                         style="position: absolute;right: 5px;top:15px;">
                                    <img v-else-if="showthis_1 === 'b'" src="../../assets/icon_hide.png" @click="show()" width="30"
                                         style="position: absolute;right: 5px;top:15px;">
                                </div>
                            </form>
                            <a class="font_mid forget" @click="forget_psw">{{$t('user_center_forget_password')}}</a>
                            <div style="clear: both"></div>
                            <div class="tip">
                                <p  style="font-size: 14px;color: #5E6D82;text-align: left;margin-top: 10px;" >
                                    {{$t('login_agree')}}
                                    <router-link class="text-primary" :to="{name: 'terms_of_service'}">
                                        {{$t('agree_terms_of_conditions')}}
                                    </router-link>
                                    ,
                                    <router-link :to="{name: 'privacy_policy'}" class="text-primary">{{$t('agree_privacy_policy')}}
                                    </router-link>
                                    {{$t('and')}}
                                    <router-link :to="{name: 'terms_of_law'}" class="text-primary">{{$t('agree_terms_of_law')}}
                                    </router-link>
                                    .
                                </p>
                            </div>
                            <div class="TouristLogin_btn">
                                <button @click="login">{{$t('tourist_member')}}</button>
                            </div>
                            <div class="tip">
                                <a>
                                    <p class="font-small" @click="changeLogin" style="text-align: center">{{$t('login_tip')}}</p>
                                </a>
                            </div>
                        </div>
                        <!--游客注册-->
                        <div class="TouristLogin_loginwrap" v-else>
                            <h2 class="font_mid">
                                {{$t('tourist_member')}}
                            </h2>
                            <form>
                                <div class="TouristLogin_name">
                                    <input type="text"  v-model="touristRisgterName" :placeholder="$t('user_center_username')">
                                </div>
                                <div class="TouristLogin_email">
                                    <input type="text"  v-model="touristRisgteremail" :placeholder="$t('user_center_email')">
                                </div>
                                <div class="TouristLogin_password" style="position: relative">
                                    <input class="Touristpassword_1" type="password" v-model="touristRisgterePsw" :placeholder="$t('user_center_password')">
                                    <img v-if="showthis_1 === 'a'" src="../../assets/icon_eye.png" @click="hide()" width="30"
                                         style="position: absolute;right: 5px;top:15px;">
                                    <img v-else-if="showthis_1 === 'b'" src="../../assets/icon_hide.png" @click="show()" width="30"
                                         style="position: absolute;right: 5px;top:15px;">
                                </div>
                            </form>
                            <div class="tip">
                                <p  style="font-size: 14px;color: #5E6D82;text-align: left;" >
                                    {{$t('login_agree')}}
                                    <router-link class="text-primary" :to="{name: 'terms_of_service'}">
                                        {{$t('agree_terms_of_conditions')}}
                                    </router-link>
                                    ,
                                    <router-link :to="{name: 'privacy_policy'}" class="text-primary">
                                        {{$t('agree_privacy_policy')}}
                                    </router-link>
                                    {{$t('and')}}
                                    <router-link :to="{name: 'terms_of_law'}" class="text-primary">
                                        {{$t('agree_terms_of_law')}}
                                    </router-link>
                                    .
                                </p>
                            </div>
                            <div class="TouristLogin_btn">
                                <button @click="registerUser">{{$t('tourist_member')}}</button>
                            </div>
                        </div>
                    </i-col>
                    <i-col :xs="24" :sm="12" :md="12" :lg="12">
                        <div class="TouristLogin_loginwrap TouristLogin_hide">
                            <h2 class="font_mid">
                                {{$t('tourist_guest')}}
                            </h2>
                            <p class="font_mid">
                                {{$t('tourist_guest_tile')}}
                            </p>
                            <div class="TouristLogin_join">
                                <h2 class="font_mid">{{$t('tourist_guest_content1')}}</h2>
                                <p class="font_mid">{{$t('tourist_guest_content2')}}</p>
                                <p class="font_mid">{{$t('tourist_guest_content3')}}</p>
                                <p class="font_mid">{{$t('tourist_guest_content4')}}</p>
                                <p class="font_mid">{{$t('tourist_guest_content5')}}</p>
                            </div>
                            <div class="TouristLogin_btn2">
                                <router-link :to="{name:'Confirmation'}" class="text-primary">
                                    <button >{{$t('tourist_guest')}}</button>
                                </router-link>
                            </div>
                        </div>
                    </i-col>
                </Row>
            </div>
            <div slot="footer"></div>
        </modal>
    </div>
</template>
<script>
    import dataImage from '../../lib/dataImage'
    import Signature from '../../lib/Signature'
    import modal from './Modal.vue'

    export default {
        name: 'navbar',
        data () {
            return {
                searchText: '',
                showthis_1:'a',
                ConectShow:false,
                // 游客登录
                touristPassword:'',
                touristName:'',
                touristRisgterName:'',
                touristRisgteremail:'',
                touristRisgterePsw:'',
                TouristLogin:false,
                TouristShow:true,
                menu: [
                    {
                        name:'iConnect',
                        to: {name: 'Connect'}
                    },

                    {
                        name:'iGo',
                        to: {name: 'Go'}
                    },

                    {
                        name: 'Travelution',
                        to: {name: 'Tranvelution'}
                    }
                ],
                submenulist:[
                    {
                        grey:require('../../assets/home/new_home/icon_mogo s_grey@2x.png'),
                        blue:require('../../assets/home/new_home/icon_mogo s_blue@2x.png'),
                        name:'MOGO S',
                        to: {path: '/product/mogos/?id=1'}
                    },
                    {
                        grey:require('../../assets/home/new_home/icon_iglobal_grey@2x.png'),
                        blue:require('../../assets/home/new_home/icon_iglobal_blue@2x.png'),
                        name:'iGlobal',
                        to: {path: '/product/iglobal/?id=9'}
                    },
                    {
                        grey:require('../../assets/home/new_home/icon_iapp_grey@2x.png'),
                        blue:require('../../assets/home/new_home/icon_iapp_blue@2x.png'),
                        name:'iAPP',
                        to: {name: 'app'}
                    },
                    {
                        grey:require('../../assets/home/new_home/icon_ivoice_grey@2x.png'),
                        blue:require('../../assets/home/new_home/icon_ivoice_blue@2x.png'),
                        name:'iVoice',
                        to: {name: 'iVoice'}
                    }
                ],
                language: [
                    {
                        value: 'English',
                        label: 'en-US'
                    },
                    {
                        value: '繁體中文',
                        label: 'zh-HK'
                    },
                    {
                        value: '简体中文',
                        label: 'zh-CN'
                    }
                ],
                fbToken: '',
                bind_email:false,
                isClose: false,
                spinShow:false,
                spinShow_forget:false,
                platform_id:0,
                isNav: 'ture',
                bind_email_email:'',
                wxlogin: 0,
                facebook_id:0,
                bind_email_psw:'',
                dropdownStatus: false,
                cache_token:'',
                profile: {},
                authorized: false,
                showMenuStatus: false,
                forget_psw_email: '',
                isShowbar: true,
                isShowbar2: false,
                searchStatus: false,
                menuIndex: 0,
                isTrans: this.transparent,
                navStatus: false,
                modal1: false,
                forget_moadl: false,
                single1: false,
                isLogin: this.Local.get('users') !== 'undefined' && this.Local.get('users') !== null,
                loginData: {
                    account: '',
                    password: ''
                },
                registerData: {
                    username: '',
                    email: '',
                    password: '',
                    repassword: ''
                },
                cartCount: 0,
                cartList: []
            }
        },
        props: {
            transparent: {
                type: Boolean,
                default: false
            },
            activeTo: {
                type: String,
                default: '/'
            }
        },
        computed: {
            nickname () {
                if (this.Local.get('users') !== 'undefined' && this.Local.get('users') !== null) {
                    return this.Local.get('users').user_info.nickname
                } else {
                    return ''
                }
            },
            defaultLanguage () {
                const lang = this.Local.get('lang') || 'en-US'
                let defaultLang
                for (let item of this.language) {
                    if (item.label === lang) {
                        defaultLang = item
                        break
                    }
                }
                return defaultLang || lang
            },
            logo: {
                get () {
                    let value = dataImage.logo.white
                    return value
                },
                set (newValue) {
                    this.value = newValue
                }
            },
            searchBtn: {
                get () {
                    let value = document.body.clientWidth > 768 ? dataImage.btn.search.white : dataImage.btn.search.black
                    return value
                },
                set (newValue) {
                    this.value = newValue
                }
            },
            unfold: {
                get () {
                    let value = document.body.clientWidth > 768 ? dataImage.btn.unfold.white : dataImage.btn.unfold.black
                    return value
                },
                set (newValue) {
                    this.value = newValue
                }
            },
            shoppingCart: {
                get () {
                    let value = dataImage.btn.cart.white
                    return value
                },
                set (newValue) {
                    this.value = newValue
                }
            },
            myUser: {
                get () {
                    let value = document.body.clientWidth > 768 ? dataImage.btn.user.white : dataImage.btn.user.black
                    return value
                },
                set (newValue) {
                    this.value = newValue
                }
            }
        },
        components: {
            modal
        },
        methods: {
            //忘记密码
            forget_psw () {
                this.TouristLogin = false
                this.forget_moadl = true
            },
            //确认忘记密码
            forget_password_next () {
                if (this.forget_psw_email === '') {
                    this.$Message.error(this.$t('add_address_email_full'))
                } else {
                    const module = 'index.php/index/user/send_email_url'
                    let data = {}
                    data.account = this.forget_psw_email
                    data.sub_time = Signature.timestamp()
                    data.lang = this.$i18n.locale
                    data.sign = Signature.create(module, data.sub_time)
                    this.spinShow_forget = true
                    this.$http.post(process.env.BASEURL + module, data).then(function (resp) {
                        if (parseInt(resp.data.code) === 2001) {
                            this.spinShow_forget = false
                            this.$Message.error(resp.data.msg)
                            return false
                        }

                        if (parseInt(resp.data.code) === 2000) {
                            this.spinShow_forget = false
                            this.$Message.success(this.$t('user_message_send_email_success'))
                            this.forget_moadl = false
                        }else{
                            this.spinShow_forget = false
                            this.$Message.error(resp.data.msg)
                            return false
                        }
                    }.bind(this))
                }

            },
            //用户注册
            registerUser () {
                const module = 'index.php/index/user/register'
                let self = this
                let data = {}
                data.sub_time = Signature.timestamp()
                data.sign = Signature.create(module, data.sub_time)
                data.register_type = 'email'
                data.lang = self.$i18n.locale
                data.email = self.touristRisgteremail
                data.password = self.touristRisgterePsw
                data.nickname = self.touristRisgterName
                self.spinShow = true
                self.$http.post(process.env.BASEURL + module, data).then(function (resp) {
                    if (parseInt(resp.data.code) === 2000) {
                        // 注册成功
                        self.spinShow = false
                        self.$Message.success(resp.data.msg)
                        self.Local.set('users', resp.data.data)
                        let timestamp = Date.parse(new Date()) / 1000
                        self.Local.set('timeout', timestamp)
                        self.isLogin = true
                        self.TouristLogin = false
                    }else{
                        self.spinShow = false
                        self.$Message.error(resp.data.msg)
                    }

                    if (parseInt(resp.data.code) === 2001) {
                        self.spinShow = false
                        self.$Message.error(resp.data.msg)
                        self.errors.has('register_email') === false
                        return false
                    }

                })
            },
            //用户登录
            login () {
                let self = this
                const module = 'index.php/index/user/login'
                let data = {}
                data.account = self.touristName
                data.lang = this.$i18n.locale
                data.password = self.touristPassword
                data.sub_time = Signature.timestamp()
                data.sign = Signature.create(module, data.sub_time)
                self.spinShow = true
                self.$http.post(process.env.BASEURL + module, data).then(function (resp) {
                    if (parseInt(resp.data.code) === 2001) {
                        self.spinShow = false
                        self.$Message.error(resp.data.msg)
                        return false
                    }
                    if (parseInt(resp.data.code) === 2000) {
                        self.spinShow = false
                        self.$Message.success(resp.data.msg)
                        self.Local.set('users', resp.data.data)
                        let timestamp = Date.parse(new Date()) / 1000
                        self.Local.set('timeout', timestamp)
                        self.isLogin = true
                        self.TouristLogin = false

                    } else {
                        self.spinShow = false
                        self.$Message.error(resp.data.msg)
                        return false
                    }
                })
            },
            //登录密码显示与隐藏
            hide(id){
                this.showthis_1 = 'b'
                $('.Touristpassword_1').attr('type','text')
            },
            show(id){
                this.showthis_1 = 'a'
                $('.Touristpassword_1').attr('type','password')

            },
            close(){
                this.TouristShow = true
                this.TouristLogin = false
            },
            //游客登录注册切换
            changeLogin () {
                this.TouristShow = false
            },
            //Conect Show
            ThisShow (i) {
                if(i == 0) {
                    this.ConectShow = true
                }else{
                    this.ConectShow = false
                }
            },
            //Conect Hide
            ConectHide (){
                this.ConectShow = false
            },
            // 绑定邮箱
            fb_bind_email () {
                if (this.bind_email_email === '' || this.bind_email_psw === '') {
                    this.$Message.error(this.$t('filled_msg'))
                    return false
                }
                let self = this
                const module = 'bandemail'
                let data = {}
                data.cache_token = self.cache_token
                data.email = self.bind_email_email
                data.platform = self.platform_id
                data.password = self.bind_email_psw
                data.lang = self.$i18n.locale
                data.sub_time = Signature.timestamp()
                data.sign = Signature.create(module, data.sub_time)
                self.spinShow = true
                self.$http.post(process.env.BASEURL + module, data).then(function (resp) {
                    if (parseInt(resp.data.code) === 2001) {
                        self.spinShow = false
                        self.$Message.error(resp.data.msg)
                        return false
                    }
                    if (parseInt(resp.data.code) === 2000) {
                        self.spinShow = false
                        self.$Message.success(resp.data.msg)
                        self.Local.set('users', resp.data.data)
                        let timestamp = Date.parse(new Date()) / 1000
                        self.Local.set('timeout', timestamp)
                        self.isLogin = true
                        self.modal1 = false
                        self.bind_email = false
                    } else {
                        self.spinShow = false
                        self.$Message.error(resp.data.msg)
                        return false
                    }
                })
            },
            getProfile () {
                FB.api('/me?fields=name,id,email', function (response) {
                    vm.$set(vm, 'profile', response)
                })
            },
            fblogin () {
                let vm = this
                FB.login(function (response) {
                    vm.statusChangeCallback(response)
                }, {
                    scope: 'email, public_profile',
                    return_scopes: true
                })
            },
            search () {
                this.$router.push({
                    name: 'Search',
                    query: {
                        q: this.searchText
                    }
                })
            },
            logout () {

                if(this.facebook_id === 1) {
                    //facebook退出登录
                    let vm = this
                    FB.logout(function (response) {
                        console.log('res when logout', response)
                        if (confirm(vm.$t('user_center_exit_the_login'))) {
                            vm.Local.unset('users')
                            vm.$router.replace('/')
                            // 重新加载页面
                            vm.$router.go(0)
                        }
                    })
                }else{
                    if (confirm(this.$t('user_center_exit_the_login'))) {
                        this.Local.unset('users')
                        this.$router.replace('/')
                        // 重新加载页面
                        this.$router.go(0)
                    }
                }

            },
            statusChangeCallback (response) {
                let vm = this
                if (response.status === 'connected') {
                    vm.authorized = true
                    vm.getProfile()
                } else if (response.status === 'not_authorized') {
                    vm.authorized = false
                } else if (response.status === 'unknown') {
                    vm.profile = {}
                    vm.authorized = false
                } else {
                    vm.authorized = false
                }
            },
            showUserMenu () {
                this.showMenuStatus = !this.showMenuStatus
                if (this.showMenuStatus) {
                    this.dropdownStatus = false
                }
            },
            toggleLanguage (label) {
                this.$i18n.locale = label
                this.Local.set('lang', label)
                window.location.reload(true)
            },
            dropdownToggle () {
                this.dropdownStatus = !this.dropdownStatus
                if (this.dropdownStatus) {
                    this.showMenuStatus = false
                }
            },
            searchToggle () {
                this.searchStatus = !this.searchStatus
                this.isNav = false
                this.isClose = true
                this.isShowbar2 = true
                this.isShowbar = false
            },
            submenuToggle (index) {
                this.menuIndex = index
            },
            menuToggle (index,go) {
                this.menuIndex = index
                this.$router.push(
                    {
                        path:go
                    }
                )
            },
            navToggle () {
                this.navStatus = !this.navStatus
            },
            close_search () {
                this.searchStatus = false
                this.isNav = true
                this.isClose = false
                this.isShowbar = true
                this.isShowbar2 = false
            },
            change (status) {
                this.scroll = document.body.scrollTop
                if (this.scroll === 0) {
                    if (this.transparent) {
                        this.logo = dataImage.logo.white
                        this.searchBtn = dataImage.btn.search.white
                        this.unfold = dataImage.btn.unfold.white
                        this.shoppingCart = dataImage.btn.cart.white
                        this.myUser = dataImage.btn.user.white
                        this.isTrans = true
                    } else {
                        this.logo = dataImage.logo.white
                        this.searchBtn = dataImage.btn.search.black
                        this.unfold = dataImage.btn.unfold.black
                        this.shoppingCart = dataImage.btn.cart.black
                        this.myUser = dataImage.btn.user.black
                    }
                } else if (this.scroll > 0) {
                    this.isTrans = false
                    this.logo = dataImage.logo.white
                    this.searchBtn = dataImage.btn.search.black
                    this.unfold = dataImage.btn.unfold.black
                    this.shoppingCart = dataImage.btn.cart.black
                    this.myUser = dataImage.btn.user.black
                }

                if (document.body.clientWidth < 920) {
                    this.isTrans = false
                }
            },
            shopping () {

                if (this.$route.name === 'ShoppingCart') {
                    return false
                }
                this.$busEvent.$emit('addCart')

                $('.Srig').animate({width: '500px'})
                $('.shopping-car-page').fadeIn(1500)
                $('.Srig-group').show()
            },
            updateCart () {
                this.$busEvent.$on('addCart', function (id) {
                    this.fetchCart()
                }.bind(this))

                this.$busEvent.$on('delcart', function (count) {
                    this.fetchCart()
                }.bind(this))
            },
            fetchCart () {
                let module = 'index.php/index/shopcar/carinfo'
                let data = {}
                data.sub_time = Signature.timestamp()
                data.sign = Signature.create(module, data.sub_time)
                data.token = this.Local.getUserToken()
                if (!this.Local.isLogin()) {
                    data.tourists_token = this.Local.get('tourists_token')
                }else{
                    data.user_id = this.Local.getUserId()
                }
                this.$http.get(process.env.BASEURL + module, {params: data})
                    .then(function (response) {
                        this.cartCount = response.data.data.length || 0
                    }.bind(this))
            },
            checkLoginState () {
                FB.getLoginStatus(function (response) {
                    statusChangeCallback(response)
                })
            },
            statusChangeCallback (response) {
                console.log(response)
                if (response.status === 'connected') {  //登陆状态已连接
                    this.fbToken = response.authResponse.accessToken
                    this.getUserInfo(this.fbToken)
                    this.facebook_id = 1
                } else if (response.status === 'not_authorized') { //未经授权
                    console.log('facebook未经授权')
                    this.facebook_id = 0
                } else {
                    console.log('不是登陆到Facebook;不知道是否授权')
                    this.facebook_id = 0
                }
            },
            //wechat登录
            wechat_login() {
                let self = this
                const module = 'wxlogin'
                let data = {}
                data.wx_token=this.wxlogin
                data.lang = self.$i18n.locale
                data.sub_time = Signature.timestamp()
                data.sign = Signature.create(module, data.sub_time)
                self.$http.post(process.env.BASEURL + module, data).then(function (resp) {
                    console.log(resp.data)
                    if (parseInt(resp.data.code) === 2001) {
                        self.$Notice.error(
                            {
                                title:resp.data.msg
                            }
                        )
                        return false
                    }
                    if (parseInt(resp.data.code) === 6000) {
                        self.bind_email = true
                        self.platform_id = 2
                        self.cache_token = resp.data.data.cache_token
                    }
                    if (parseInt(resp.data.code) === 2000) {
                        self.$Notice.success(
                            {
                                title:resp.data.msg
                            }
                        )
                        self.Local.set('users', resp.data.data)
                        let timestamp = Date.parse(new Date()) / 1000
                        self.Local.set('timeout', timestamp)
                        self.isLogin = true
                        self.modal1 = false
                        self.facebook_login = 1
                    } else {
                        self.$Notice.error(
                            {
                                title:resp.data.msg
                            }
                        )
                        return false
                    }
                })
            },
            // 获取用户信息
            getUserInfo (fbToken) {
                let vm = this
                FB.api('/me', function (response) {
                    vm.third_login(response,fbToken,1)
                })
            },
            loginThis () {
                this.$router.push({
                    name: 'Login'
                })
            }
        },
        created () {
            //初始化购物车
            this.fetchCart()

            //更新请求购物车列表
            this.updateCart()

            //判断用户为登录，激发弹窗
            this.$busEvent.$on('login', function () {
                this.TouristLogin = true
            }.bind(this))

            //判断用户为忘记密码，激发弹窗
            this.$forget.$on('forget', function () {
                this.forget_moadl = true
            }.bind(this))

            localStorage.setItem('timestamp', this.Local.timestamp())
        },
        mounted () {
            if (document.body.clientWidth < 920) {
                this.isTrans = false
            }
            window.addEventListener('scroll', this.change)

            console.log(this.Local.get('users'))

            //facebook login
            // facebook 初始化
            let vm = this
            window.fbAsyncInit = function() {
                FB.init({
                    appId: '386185291829616',
                    cookie: true,
                    xfbml: true,
                    version: 'v2.11'
                });
                FB.AppEvents.logPageView();

                // Get FB Login Status
                FB.getLoginStatus( response => {
                    vm.statusChangeCallback(response)
                })
            }

            //wechat 获取是否有wxlogin
            this.wxlogin = this.$route.query.wxlogin

            //调用wexlogin方法进行微信登录
            if(this.wxlogin){
                this.wechat_login()
            }
        }
    }
</script>
<style lang="scss" type="text/scss" scoped>
    @import "../../scss/components/toast";
    @import "../../scss/navbar";
    @import "../../scss/common";
    @import "../../scss/components/form";
    /*绑定邮箱*/
    .bind_email{
        .bind_email_title{
            h2{
                padding: 0 10px 0 10px;
                font-size: 24px;
                color: #0084FF !important;
                font-weight: 300;
            }
        }
        .bind_email_sm-title{
            p{
                padding: 0 10px 10px 10px;
                max-width: 320px;
                text-align: left;
                margin: 0 auto;
            }
        }
        .bind_email_input{
            padding: 0 10px 10px 10px;
            input{
                padding:7px;
                width: 85%;
                border-radius: 5px;
                border: 1px solid #5E6D82;
            }
        }
        .bind_email_determine{
            button{
                background: #0084FF;
                border-radius: 5px;
                border: none;
                width:45%;
                height: 40px;
                color: white;
            }
        }
    }
    /*忘记密码*/
    .forget_password {

        .forget_password-title {
            h2 {
                font-size: 24px;
                color: #1F2D3D;
                font-weight: 500;
                margin: 15px 0 15px 0;
            }
        }
        .forget_password-sm-title {
            text-align: left;
            width: 70%;
            margin: 0 auto;
        }
        .forget_password-main {
            margin: 10px 0 10px 0;
            input {
                width: 71%;
                border: 1px solid #99A9BF;
                border-radius: 5px;
                padding: 8px 10px 10px 8px;
            }
        }
        .forget_password-tip {
            width: 70%;
            margin: 0 auto;
            text-align: left;
            p {
                font-size: 16px;
                color: #5E6D82;
            }
        }
        .forget_password-nex-btn {
            button {
                background: #0084FF;
                border-radius: 5px;
                height: 34px;
                width: 45%;
                color: white !important;
                border: none;
                margin: 25px 0 15px 0;
            }

        }
    }

    /*游客登录*/
     .TouristLogin{
         .font_big{
             /*font-family: PingFangSC-Medium;*/
             font-size: 24px;
             color: #1F2D3D !important;
             letter-spacing: 0;
             line-height: 38px;
             font-weight: 500;
         }
         .font_mid{
             /*font-family: PingFangSC-Medium;*/
             font-size: 16px;
             color: #1F2D3D;
             letter-spacing: 0;
             line-height: 22px;
             font-weight: 500;
         }
         .font-small{
             /*font-family: PingFangSC-Regular;*/
             font-size: 14px;
             color: #1F2D3D;
             letter-spacing: 0;
             line-height: 21px;
         }
         .TouristLogin_title{
             margin: 30px 0;
         }
         .TouristLogin_login{
             border-right:2px solid #979797;
         }
         .TouristLogin_loginwrap{
             max-width: 340px;
             margin:0 auto;
             text-align: left;
             h2{
                 margin-bottom: 5px;
             }
             input{
                 padding: 10px 35px 10px 9px;
                 border: 1px solid #5E6D82;
                 border-radius: 5px;
                 margin:8px auto;
                 width: 100%;
             }
             .forget{
                 float: right;
             }
             .TouristLogin_btn{
                 button{
                     width: 100%;
                     height: 40px;
                     /*font-family: PingFangSC-Medium;*/
                     font-size: 20px;
                     color: #FFFFFF;
                     background: #0084FF;
                     border-radius: 5px;
                     margin: 30px auto 20px auto;
                     border: none;
                 }
             }
             .TouristLogin_btn2{
                 button{
                     width: 100%;
                     height: 40px;
                     /*font-family: PingFangSC-Medium;*/
                     font-size: 20px;
                     color: #0084ff;
                     background:transparent;
                     border-radius: 5px;
                     margin: 51px auto 20px auto;
                     border: 1px solid #0084ff;
                     &:hover{
                         background: #0084ff;
                         color: #ffffff;
                     }
                 }
             }
             .TouristLogin_join{
                 h2{
                     margin-bottom: 10px;
                 }
                 p{
                     margin-bottom: 5px;
                 }
             }
         }
         @media (max-width:500px) {
             .TouristLogin_login{
                 border:none;
             }
             .page-content{
                 height: 500px;
                 overflow-y: scroll;
             }
             .TouristLogin_hide{
                 display: none;
             }
         }
         @media (max-width:320px) {
             .page-content{
                 height: 400px;
                 overflow-y: scroll;
             }
         }
     }
    //忘记密码
    .forget_password {
        .forget_password-title {
            h2 {
                font-size: 24px;
                color: #1F2D3D;
                font-weight: 500;
                margin: 15px 0 15px 0;
            }
        }
        .forget_password-sm-title {
            text-align: left;
            width: 70%;
            margin: 0 auto;
        }
        .forget_password-main {
            margin: 10px 0 10px 0;
            input {
                width: 71%;
                border: 1px solid #99A9BF;
                border-radius: 5px;
                padding: 8px 10px 10px 8px;
            }
        }
        .forget_password-tip {
            width: 70%;
            margin: 0 auto;
            text-align: left;
            p {
                font-size: 16px;
                color: #5E6D82;
            }

        }
        .forget_password-nex-btn {
            button {
                background: #0084FF;
                border-radius: 5px;
                height: 34px;
                width: 45%;
                color: white !important;
                border: none;
                margin: 25px 0 15px 0;
            }

        }
    }

</style>



// WEBPACK FOOTER //
// Navbar.vue?768aac3c